var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloseCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.515 30.485c-.347-.347-.337-.92.024-1.281l15.665-15.665c.36-.36.934-.371 1.281-.024.348.347.337.92-.024 1.281L14.796 30.461c-.36.36-.934.371-1.281.024z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.515 13.515c.347-.347.92-.337 1.281.024l15.665 15.665c.36.36.372.934.024 1.281-.347.347-.92.337-1.28-.024L13.538 14.796c-.36-.36-.371-.934-.024-1.281z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy41MTQ4IDMwLjQ4NTNDMTMuMTY3NiAzMC4xMzgyIDEzLjE3ODUgMjkuNTY0NSAxMy41Mzg5IDI5LjIwNEwyOS4yMDQxIDEzLjUzODlDMjkuNTY0NSAxMy4xNzg1IDMwLjEzODIgMTMuMTY3NiAzMC40ODUzIDEzLjUxNDdDMzAuODMyNSAxMy44NjE5IDMwLjgyMTYgMTQuNDM1NiAzMC40NjEyIDE0Ljc5NkwxNC43OTYgMzAuNDYxMUMxNC40MzU1IDMwLjgyMTYgMTMuODYxOSAzMC44MzI0IDEzLjUxNDggMzAuNDg1M1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNTE0OCAxMy41MTQ3QzEzLjg2MTkgMTMuMTY3NiAxNC40MzU1IDEzLjE3ODQgMTQuNzk2IDEzLjUzODlMMzAuNDYxMiAyOS4yMDRDMzAuODIxNiAyOS41NjQ1IDMwLjgzMjUgMzAuMTM4MiAzMC40ODUzIDMwLjQ4NTNDMzAuMTM4MiAzMC44MzI0IDI5LjU2NDUgMzAuODIxNiAyOS4yMDQxIDMwLjQ2MTFMMTMuNTM4OSAxNC43OTZDMTMuMTc4NSAxNC40MzU1IDEzLjE2NzYgMTMuODYxOSAxMy41MTQ4IDEzLjUxNDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconCloseCross as ReactComponent };